import {
  EnvironmentInjector,
  Service,
  effect,
  inject,
  runInInjectionContext,
} from '@angular/core';
import { Metatag } from '@app/models/entity.model';
import { DrupalService } from '@app/services/drupal.service';
import { DOCUMENT } from '@angular/common';

@Service()
export class MetatagService {
  #hasRobots: boolean = false;
  #drupal = inject(DrupalService);
  #doc = inject(DOCUMENT);
  #injector = inject(EnvironmentInjector);

  initialize() {
    runInInjectionContext(this.#injector, () => {
      effect(() => {
        const metatags = this.#drupal.route()?.metatags;
        this.#hasRobots = false;
        if (!metatags?.length) return;
        this.#removeMetatags(metatags);
        this.#addMetatags(metatags);
      });
    });
  }

  #addMetatags(tags: Metatag[]) {
    tags.forEach((tag: Metatag) => {
      // Prevent duplicates
      if (this.#doc.querySelector(this.#getTagSelector(tag))) return;
      const definition: HTMLElement = this.#doc.createElement(tag.tag);
      tag.attributes.forEach((attr: { key: string; value: string }) => {
        if (attr.value === 'robots') {
          this.#hasRobots = true;
        }
        definition.setAttribute(attr.key, attr.value);
      });
      this.#doc.head.appendChild(definition);
    });

    if (!this.#hasRobots) {
      const definition: HTMLElement = this.#doc.createElement('meta');

      definition.setAttribute('name', 'robots');
      definition.setAttribute('content', 'index, follow');
      this.#doc.head.appendChild(definition);
    }
  }

  #removeMetatags(tags: Metatag[]) {
    tags.forEach((tag: Metatag) => {
      this.#doc.querySelector(this.#getTagSelector(tag))?.remove();
    });

    if (!this.#hasRobots) {
      this.#doc.querySelector('meta[name="robots"]')?.remove();
    }
  }

  #getTagSelector(tag: Metatag): string {
    const attributes = tag.attributes
      .map((attr: { key: string; value: string }) => {
        const value = attr.value.replace(/"/g, '\\"');
        return `[${attr.key}="${value}"]`;
      })
      .join('');

    return `${tag.tag}${attributes}`;
  }
}
